import restaurantInstance from '../instance'

const fetchTable = (tableId) => {
	return restaurantInstance.get(`/tables/${tableId}`)
}

export default fetchTable
